import { Checkbox } from "antd";
import React from "react";

export const EmptyState = () => {
  return (
    <div className="mt-40 flex flex-col items-center justify-center">
      <div className="w-14 h-14 flex items-center justify-center bg-green rounded-full">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="none"
          viewBox="0 0 28 28"
        >
          <path
            stroke="#FAD152"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M10.499 25.667h7c5.833 0 8.166-2.334 8.166-8.167v-7c0-5.833-2.333-8.166-8.166-8.166h-7c-5.834 0-8.167 2.333-8.167 8.166v7c0 5.834 2.333 8.167 8.167 8.167M18.375 10.5h-8.75M18.375 17.5h-8.75"
          />
        </svg>
      </div>

      <p className="mt-6 font-poppins font-medium text-base text-center">
        Select Duration
      </p>

      <p className="mt-2 font-poppins font-light text-xs text-center">
        Select your start and end dates to populate the list of farmers.
      </p>
    </div>
  );
};

export const ColumnHeader = ({ selected, onCheckboxClick, onSortClick }) => {
  return (
    <div className="bg-background flex items-center border-b-[0.5px] border-light-grey">
      <div className="w-10 py-2.5 px-3 h-9 flex items-center justify-center">
        <Checkbox checked={selected} onClick={onCheckboxClick} />
      </div>

      <div className="flex-1 flex items-center py-2.5 px-3 h-9 gap-x-1">
        <p className="font-aileron font-normal text-10 text-[#667085]">Name</p>

        <button type="button" onClick={onSortClick}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
          >
            <path
              fill="#525252"
              d="m4.668 10 3.333 3.334L11.335 10zM4.668 6l3.333-3.333L11.335 6z"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};
